export const colors = {
    primary:'#ECFDF5',
    secondary:'#907EFF',
    black:'#03031B',
    white:'#FFFFFF',
    gray:"#C0C0C0",
    gray2:'#FAFAFA',
    accent:"#C0EC4E",
    green:"#3cb371",
    red:"#D2042D"
};
// "#64748B"
// #dcdcdc
// #F4FEFE
//gray2:'#e8e6e6',
//whitegris:'#f0f0f0'
// "#f5f5f5"


//'#F2F2F2'